import { useContext } from 'react';
import { LoyaltyContext } from '../providers';

export function useLoyaltyContext() {
    const context = useContext(LoyaltyContext);

    if (context === undefined || context === null) {
        throw new Error('useLoyaltyContext must be used within a LoyaltyContext');
    }

    return context;
}
